
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 35.139 39.552"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"flashdeal","d":"M35.14 16.236H22.205L31.198.004H12.919L.001 23.324h13.874L4.882 39.556z","fill":"#ffde59"}})])
          )
        }
      }
    